// we are editing this.touchState class variable so we reassign params in this file
/* eslint-disable no-param-reassign */

import isFunction from 'lodash/isFunction';
import { createEvent, createSwipe } from './event-mappers';

const stopPropagationMethods = {};
let isPropagationBlocked = {};

/**
 * handle props object event
 * @param {string} eventName - event
 * @param {object} props - from above
 * @param {object} e - browser event
 */
const handleEvent = function handleEvent(eventName, props, e) {
  if (!isPropagationBlocked[eventName] && isFunction(props[eventName])) {
    e.stopPropagation = stopPropagationMethods[eventName];
    props[eventName](e);
  }
};

/**
 * handle event start
 * @param {object} props - from react component
 * @param {object} state - instance variable from react component
 * @param {object} originalEvent - browser event
 * @param {object} domElement - ref
 * @returns {undefined}
 */
const handleStart = function handleStart(props, state, originalEvent, domElement) {
  const event = createEvent(state, originalEvent, domElement);

  // remove all event propogation short circuits
  isPropagationBlocked = {};

  // reset the touch state
  Object.assign(state, {
    swipePositions: [],
    target: event.currentTarget,
    totalX: 0,
    totalY: 0,
    totalDistance: 0
  });

  const swipePosition = createSwipe(state, event);

  if (swipePosition.pageX !== undefined) {
    state.swipePositions.unshift(swipePosition);

    handleEvent('onSwipeStart', props, swipePosition);
    handleEvent('onSwipe', props, swipePosition);
  }
};

/**
 * handle move event
 * @param {object} props - from react component
 * @param {object} state - instance variable from react component
 * @param {object} originalEvent - from browser
 * @param {Node} domElement - ref
 * @returns {undefined}
 */
const handleMove = function handleMove(props, state, originalEvent, domElement) {
  const MAXIMUM_POSITIONS_ARRAY_LENGTH = 3;

  const event = createEvent(state, originalEvent, domElement);
  const swipePosition = createSwipe(state, event);

  state.swipePositions.unshift(swipePosition);

  delete state.swipePositions[MAXIMUM_POSITIONS_ARRAY_LENGTH];

  handleEvent('onSwipe', props, swipePosition);
};

/**
 * handle event end
 * @param {object} props - from react component
 * @param {object} state - instance variable from react component
 * @returns {undefined}
 */
const handleEnd = function handleEnd(props, state) {
  handleEvent('onSwipeEnd', props, state.swipePositions[0]);
};

export { handleEnd, handleMove, handleStart };
